import straivLogoLight from "@/assets/straiv-logo-light.png";
import straivLogoFallback from "@/assets/straiv-logo.png";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const LegalInfo = () => {
  const [logoSrc, setLogoSrc] = useState(straivLogoLight);

  return (
    <div
      className="bg-gradient-bg min-h-screen flex flex-col items-center p-4 overflow-y-auto"
      style={{
        paddingTop: "calc(env(safe-area-inset-top, 0px) + 24px)",
        paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 32px)",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <div className="w-full max-w-2xl mx-auto space-y-6">
        {/* Header with back button and logo */}
        <div className="flex items-center gap-4">
          <Button
            variant="outline"
            size="sm"
            asChild
            className="border-border/50 text-muted-foreground hover:text-foreground"
          >
            <Link to="/auth">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back
            </Link>
          </Button>
          <div className="flex items-center justify-center flex-1">
            <img
              src={logoSrc}
              alt="Straiv"
              className="h-10 w-auto object-contain max-w-[140px]"
              onError={() => {
                if (logoSrc !== straivLogoFallback) setLogoSrc(straivLogoFallback);
              }}
            />
          </div>
          <div className="w-[72px]" />
        </div>

        <Card className="bg-gradient-card border-border/50">
          <CardContent className="p-6 sm:p-8 space-y-8">
            <h1 className="text-2xl sm:text-3xl font-bold text-foreground">
              Legal Information
            </h1>

            <section className="space-y-4">
              <p className="text-muted-foreground leading-relaxed">
                Straiv is a service provided by:
              </p>
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">
                Masterprompt AB
              </h2>
            </section>

            <section className="space-y-3 text-muted-foreground leading-relaxed">
              <div className="grid grid-cols-[120px_1fr] sm:grid-cols-[140px_1fr] gap-y-2">
                <span className="text-sm font-medium text-foreground/80">
                  Organization no.
                </span>
                <span>559558-0928</span>

                <span className="text-sm font-medium text-foreground/80">
                  Registered office
                </span>
                <span>Alströmergatan 32 d, 112 47 Stockholm, Sweden</span>

                <span className="text-sm font-medium text-foreground/80">
                  VAT number
                </span>
                <span>SE559558092801</span>

                <span className="text-sm font-medium text-foreground/80">
                  D-U-N-S Number
                </span>
                <span>351598489</span>

                <span className="text-sm font-medium text-foreground/80">
                  Contact
                </span>
                <a
                  href="mailto:circletester123@gmail.com"
                  className="text-primary hover:underline inline-flex items-center gap-1.5"
                >
                  <Mail className="h-3.5 w-3.5" />
                  circletester123@gmail.com
                </a>
              </div>
            </section>

            <Separator />

            <p className="text-sm text-muted-foreground leading-relaxed">
              Masterprompt AB is a limited liability company registered in Sweden
              with the Swedish Companies Registration Office (Bolagsverket).
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

function Separator() {
  return <div className="h-px bg-border/50 w-full" />;
}
